@if (inventoryAction()) {
  <mat-toolbar class="header">
    <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      {{ title }}
    </div>
    <div class="expander"></div>
    <button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        (click)="sendBuyOrder()"
        *ngIf="!isAnswered && !isFinished"
      >
        <mat-icon>send</mat-icon> Reenviar Orden de Compra
      </button>
      <button
        mat-menu-item
        *ngIf="(canUpdate | async) && !isAnswered && !isFinished"
        go-to-edit
        [id]="inventoryAction().id"
        [type]="inventoryAction().type"
        (afterClosed)="reloadInventoryAction()"
      >
        <mat-icon>edit</mat-icon> Editar Orden de Compra
      </button>
      <button mat-menu-item (click)="addChat()"><mat-icon>chat</mat-icon> Agregar al Chat</button>
    </mat-menu>
  </mat-toolbar>
  
  <div class="dialog-wrapper">
    @if(loading()) {
      <mat-spinner></mat-spinner>
    } @else {
      <div class="status-chips">
        <app-chip [color]="inventoryAction().status?.color" [text]="inventoryAction().status?.name"></app-chip>
        <app-chip [color]="isAnswered ? 'green' : 'red'" [text]="isAnswered ? 'Respondida' : 'Sin respuesta'"></app-chip>
      </div>
  
      <div class="info">
        <div class="name">{{adminService.getText('warehouse')}}</div>
        <div class="value">{{inventoryAction().warehouse?.name | titlecase}}</div>
        <div class="name">Nombre Proveedor</div>
        <div class="value">{{inventoryAction().owner?.name | titlecase}}</div>
        <div class="name">Correo Proveedor</div>
        <div class="value">{{inventoryAction().owner?.email | titlecase}}</div>
        <div class="name">Fecha de Creacion</div>
        <div class="value">{{inventoryAction().created_at | date}}</div>
        @if (inventoryAction().extra_params?.required_delivery_date) {
          <div class="name">Fecha Requerida para Entrega</div>
          <div class="value">{{inventoryAction().extra_params?.required_delivery_date | date}}</div>
        }
        @if (isAnswered) {
          <div class="name">Fecha de Entrega</div>
          <div class="value">{{inventoryAction().estimated_completion_date | date}}</div>
        }
        @if (isFinished) {
          <div class="name">Fecha de Finalización</div>
          <div class="value">{{inventoryAction().completed_at | date}}</div>
        }
        @if (inventoryAction().comment) {
          <div class="name">Comentario del Proveedor</div>
          <div class="value">{{inventoryAction().comment}}</div>
        }
      </div>
  
      @if (answeredAt) {
        <div class="label">
          <p>Respondida el {{answeredAt | date}}</p>
        </div>
      }
      <div class="transfer-table-wrapper display-desktop">
        <table class="transfer-table">
          <thead>
            <tr>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Precio Unitario</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            @for (inventory_action_product of inventoryAction().inventory_action_products; track inventory_action_product.id) {
              <tr>
                <td>
                  <div>
                    <div class="name">{{inventory_action_product.product.name}}</div>
                    <div class="code">{{inventory_action_product.product.code}}</div>
                  </div>
                </td>
                <td>
                    {{inventory_action_product.quantity}}
                </td>
                <td>
                  {{inventory_action_product.amount | money}}
                </td>
                <td>
                  {{inventory_action_product.amount * inventory_action_product.quantity | money}}
                </td>
              </tr>
            }
            <tr>
              <td></td>
              <td></td>
              <td>IVA:</td>
              <td>{{ IVA | money }}
              </td>
            </tr>
            <tr class="last_row">
              <td></td>
              <td></td>

              <td class="total_column">Total:</td>
              <td class="total_column">{{ Total | money }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="products display-mobile">
        @for (inventory_action_product of inventoryAction().inventory_action_products; ; track inventory_action_product.id) {
          <div class="card product">
            <div class="card-content">
              <div class="card-details">
                <div class="row">
                  <span class="light">#{{inventory_action_product.product.code }}</span>
                </div>
                <div class="row title">
                  <span class="bold">{{inventory_action_product.product.name}}</span>
                </div>
                <div class="row">
                  <span>{{inventory_action_product.quantity}} {{inventory_action_product.unit}} x {{inventory_action_product.amount | money}}</span>
                </div>
                <div class="row">
                  <span class="bold">
                    {{inventory_action_product.amount * inventory_action_product.quantity | money}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
         <div class="card product">
            <div class="card-content">
              <div class="card-details">
                <div class="row">
                  <span class="light">Subtotal: {{ Subtotal | money }}</span>
                </div>
                <div class="row">
                  <span class="light">IVA: {{ IVA | money }}</span>
                </div>
                <div class="row">
                  <span class="bold">Total: {{ Total | money }}</span>
                </div>
              </div>
            </div>
         </div>
      </div>
        
      <div class="works-container">
        <app-document-works [order]="inventoryAction()" (load)="this.reloadInventoryAction()()" [modalComponent]="true"></app-document-works>
      </div>
    }
  </div>
}
